<template>
    <div class="bloco-estrutura" v-if="listaProdutos.length">
        <div class="section__title">Produtos do projeto</div>
        <div class="estrutura-list">
            <div v-for="(produto, index) in listaProdutos" :key="produto.produto_cod || index" class="produto-raiz">
                <div class="item-container"
                    :class="{ 'has-children': hasEstrutura(produto), 'is-open': estaExpandido(produto) }"
                    @click="toggleExpand(produto)">
                    <i :class="caretIcon(produto)"></i>
                    <!-- <span :class="classeTipo(produto.tipo)" class="tipo-produto"></span> -->
                    <div class="item-description alinha-v">
                        <a :href="urlProduto(produto)" target="_blank" @click.stop class="link-produto"
                            title="Abrir no cadastro de produtos">
                            <span>{{ produto.cod || produto.produto_cod }} - {{ produto.desc || '—' }}</span>
                        </a>
                        <i v-if="!somenteLeitura" class="bi-trash-fill btn-remover-vinculo" title="Remover vínculo do projeto"
                            @click.stop="abrirModalRemover(produto)"></i>
                    </div>
                </div>
                <div v-if="estaExpandido(produto)" class="child-items">
                    <template v-if="estruturaPorProduto[produtoKey(produto)]?.length">
                        <EstruturaItem v-for="(item, idx) in estruturaPorProduto[produtoKey(produto)]"
                            :key="item.id || idx" :item="item" />
                    </template>
                    <div v-else class="sem-estrutura">Sem estrutura cadastrada</div>
                </div>
            </div>
        </div>
        <div v-if="carregandoProdutos" class="carregando-produtos" role="status" aria-live="polite"
            aria-label="Carregando catálogo de produtos">
            <div class="loading"><div></div></div>
            <span>Carregando catálogo de produtos...</span>
        </div>
        <div v-if="!somenteLeitura" class="item-container" style="gap: 1rem;">
            <AutoCompleteProdutos :BaseOpcoes="propProdutos" :propPlaceholder="'Vincular produto existente'"
                :carregando="carregandoProdutos" @adicionar="adicionarProduto" />
            <a :href="url" target="_blank">
                <button class="acao-secundaria">
                    Cadastrar Novo Produto
                </button>
            </a>
        </div>
    </div>
    <div v-else class="margem texto-secundario">
        <div class="section__title">Produtos do projeto</div>
        <div v-if="carregandoProdutos" class="carregando-produtos" role="status" aria-live="polite"
            aria-label="Carregando catálogo de produtos">
            <div class="loading"><div></div></div>
            <span>Carregando catálogo de produtos...</span>
        </div>
        <p v-else-if="!somenteLeitura">Nenhum produto vinculado ao projeto.</p>
        <div v-if="!somenteLeitura" class="item-container" style="gap: 1rem;">
            <AutoCompleteProdutos :BaseOpcoes="propProdutos" :propPlaceholder="'Vincular produto existente'"
                :carregando="carregandoProdutos" @adicionar="adicionarProduto" />
            <a :href="url" target="_blank">
                <button class="acao-secundaria">
                    Cadastrar Novo Produto
                </button>
            </a>
        </div>
    </div>
    <!-- Modal confirmar remoção do vínculo -->
    <div v-if="modalRemoverVinculo" class="modal-mask" @click.self="fecharModalRemover">
        <div class="modal-confirmacao">
            <div class="modal-header">
                <h3>Remover vínculo</h3>
            </div>
            <p class="modal-body">
                Deseja remover o produto <strong>{{ produtoParaRemover ? (produtoParaRemover.cod ||
                    produtoParaRemover.produto_cod) + ' - ' + (produtoParaRemover.desc || '—') : '' }}</strong> do
                projeto? <br> Isto não apagará o produto do cadastro de produtos.
            </p>
            <div class="modal-footer">
                <button type="button" class="acao-secundaria" @click="fecharModalRemover">Cancelar</button>
                <button type="button" @click.stop="confirmarRemoverVinculo">Desvincular</button>
            </div>
        </div>
    </div>
</template>
<script>
import { getWebSocketService } from '@/services/websocketservice.js';
import AutoCompleteProdutos from '../AutoComplete/AutoCompleteProdutos.vue';
import EstruturaItem from '../EstruturaArvore/EstruturaItem.vue';
import serviceProjetos from '@/services/serviceProjetos';

const wsService = getWebSocketService();

export default {
    name: 'ProdutosView',
    props: {
        propProjeto: {
            required: true,
        },
        propProdutos: {
            required: true,
        },
        carregandoProdutos: {
            type: Boolean,
            default: false,
        },
        somenteLeitura: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            expandidos: {},
            url: '',
            modalRemoverVinculo: false,
            produtoParaRemover: null,
        };
    },
    computed: {
        projetoId() {
            return this.propProjeto?.id ?? null;
        },
        listaProdutos() {
            const prods = this.propProjeto?.produtos ?? [];
            return Array.isArray(prods) ? prods : [];
        },
        estruturaPorProduto() {
            const map = {};
            this.listaProdutos.forEach((p) => {
                const key = this.produtoKey(p);
                const est = this.getEstruturaArray(p);
                map[key] = est.map((n) => this.normalizarNo(n)).filter(Boolean);
            });
            return map;
        },
    },
    watch: {
        propProjeto: {
            immediate: true,
            handler(p) {
                if (p?.id) {
                    this.url =
                        process.env.NODE_ENV === 'development'
                            ? `http://localhost.thalamus.ind.br:8081/#/cadastroProduto?projetoId=${p.id}&tipo=${encodeURIComponent('Produto Acabado')}`
                            : `https://produtos.thalamus.ind.br/#/cadastroProduto?projetoId=${p.id}&tipo=${encodeURIComponent('Produto Acabado')}`;
                }
            },
        },
    },
    created() {
        wsService.addListener(this.handleWebSocketMessage);
    },
    beforeUnmount() {
        wsService.removeListener(this.handleWebSocketMessage);
    },
    methods: {
        async adicionarProduto(produto) {
            if (this.somenteLeitura) return
            await serviceProjetos.associarProdutoProjeto(this.projetoId, produto.produto_cod);
            this.$emit('getProjeto', this.projetoId);
        },
        urlProduto(produto) {
            const cod = produto?.produto_cod ?? produto?.id;
            if (!cod) return '#';
            const base =
                process.env.NODE_ENV === 'development'
                    ? 'http://localhost.thalamus.ind.br:8081'
                    : 'https://produtos.thalamus.ind.br';
            return `${base}/#/catalogo/produto/${cod}`;
        },
        hasEstrutura(produto) {
            const est = produto?.estrutura_produto ?? produto?.estruturaProduto;
            return Array.isArray(est) && est.length > 0;
        },
        getEstruturaArray(produto) {
            const est = produto?.estrutura_produto ?? produto?.estruturaProduto;
            return Array.isArray(est) ? est : [];
        },
        estruturaNormalizada(produto) {
            const est = this.getEstruturaArray(produto);
            return est.map((n) => this.normalizarNo(n));
        },
        normalizarNo(no) {
            if (!no || typeof no !== 'object') return null;
            const produto = no.produto ?? no;
            const tipo = produto?.tipo ?? no.tipo;
            const tipoNome = typeof tipo === 'string' ? tipo : (tipo?.nome ?? '');
            const filhosRaw = no.filhos ?? no.estrutura_produto ?? no.estruturaProduto;
            const filhos = Array.isArray(filhosRaw) ? filhosRaw : [];
            return {
                id: no.id,
                produto_cod: produto?.produto_cod ?? no.produtoF_cod ?? no.produto_f_cod,
                produto_codigo: produto?.cod ?? no.produto_codigo ?? String(no.produtoF_cod ?? no.produto_f_cod ?? ''),
                produto_desc: produto?.desc ?? no.produto_desc ?? '—',
                produto_tipo: tipoNome,
                qt: no.qt,
                unidade: produto?.und ?? no.unidade ?? '',
                filhos: filhos.map((f) => this.normalizarNo(f)).filter(Boolean),
            };
        },
        produtoKey(produto) {
            const id = produto?.produto_cod ?? produto?.id;
            return id != null ? String(id) : '';
        },
        estaExpandido(produto) {
            return Boolean(this.expandidos[this.produtoKey(produto)]);
        },
        caretIcon(produto) {
            if (!this.hasEstrutura(produto)) return 'bi-dash-square';
            return this.estaExpandido(produto) ? 'bi-caret-down-square' : 'bi-caret-right-square';
        },
        classeTipo(tipo) {
            if (!tipo) return '';
            const nome = typeof tipo === 'string' ? tipo : tipo?.nome ?? '';
            if (nome.includes('Matéria') || nome === 'Embalagem') return 'materia-prima';
            if (nome.includes('Processo')) return 'produto-processo';
            if (nome.includes('Acabado')) return 'produto-acabado';
            return '';
        },
        toggleExpand(produto) {
            if (!this.hasEstrutura(produto)) return;
            const key = this.produtoKey(produto);
            this.expandidos = { ...this.expandidos, [key]: !this.expandidos[key] };
        },
        codigoProduto(produto) {
            const cod = produto?.produto_cod ?? null;
            return cod != null && cod !== '' ? cod : null;
        },
        abrirModalRemover(produto) {
            if (this.somenteLeitura) return
            this.produtoParaRemover = produto;
            this.modalRemoverVinculo = true;
        },
        fecharModalRemover() {
            this.modalRemoverVinculo = false;
            this.produtoParaRemover = null;
        },
        async confirmarRemoverVinculo() {
            if (this.somenteLeitura) return
            if (!this.produtoParaRemover) return;
            const produtoCod = this.codigoProduto(this.produtoParaRemover);
            if (!this.projetoId || produtoCod == null) {
                if (process.env.NODE_ENV !== 'production') {
                    console.warn('ProdutosView: não foi possível obter projeto_id/produto_cod para desvincular');
                }
                this.fecharModalRemover();
                return;
            }
            try {
                await serviceProjetos.desassociarProdutoProjetoPorCodigo(this.projetoId, produtoCod);
                this.$emit('getProjeto', this.projetoId);
                this.fecharModalRemover();
            } catch (err) {
                if (process.env.NODE_ENV !== 'production') console.error(err);
                this.fecharModalRemover();
            }
        },
        handleWebSocketMessage(event) {
            try {
                const raw = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
                const payload = raw?.data ?? raw;
                const message = payload?.message ?? raw?.message;
                const id = payload?.id ?? raw?.id;
                if (message === 'atualizarProjetoProdutos' && id != null && Number(id) === Number(this.projetoId)) {
                    this.$emit('getProjeto', this.projetoId);
                }
            } catch {
                return;
            }
        },
    },
    components: {
        AutoCompleteProdutos,
        EstruturaItem,
    },
};
</script>
<style scoped>
.bloco-estrutura {
    margin-top: 1rem;
}

.section__title {
    font-weight: 700;
    margin-bottom: 0.75rem;
    font-size: 0.95rem;
}

.estrutura-list {
    border: 1px solid var(--cor-separador, #ddd);
    border-radius: 6px;
    overflow-x: auto;
    overflow-y: visible;
}

.produto-raiz {
    border-bottom: 1px solid var(--cor-separador, #eee);
}

.produto-raiz:last-child {
    border-bottom: none;
}

.item-container {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 8px 10px;
    gap: 0.35rem;
}

.item-container:hover {
    background-color: var(--cor-primaria-fraca, rgba(0, 0, 0, 0.04));
}

.has-children .item-container i:first-of-type {
    margin-right: 4px;
}

.is-open .item-container i:first-of-type {
    color: var(--cor-primaria);
}

.link-produto {
    color: inherit;
    text-decoration: none;
    cursor: pointer;
}

.link-produto:hover {
    text-decoration: underline;
}

.item-description {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.tipo-produto {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
}

.materia-prima {
    background-color: white;
    border: 1px solid #000;
}

.produto-processo {
    background-color: #ffd900;
}

.produto-acabado {
    background-color: #00ff15;
}

.child-items {
    margin-left: 20px;
    padding-left: 8px;
    border-left: 1px solid var(--cor-separador, #eee);
    margin-bottom: 4px;
}

.estrutura-item .item-container {
    padding: 5px 8px;
}

.qtdUnidade {
    background-color: var(--cor-cinza, #f0f0f0);
    border-radius: 6px;
    padding: 2px 8px;
    font-size: 0.9em;
    white-space: nowrap;
}


.sem-estrutura {
    padding: 8px 20px;
    color: var(--cor-secundaria, #666);
    font-size: 0.9rem;
}

.texto-secundario {
    color: var(--cor-secundaria, #666);
}

.carregando-produtos {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
    color: var(--cor-secundaria, #666);
}

.carregando-produtos .loading {
    transform: scale(0.65);
    transform-origin: left center;
}

i {
    font-size: 15px;
}

.btn-remover-vinculo {
    cursor: pointer;
    color: var(--cor-fonte-fraca,);
    margin-left: 0.5rem;
    font-size: 16px;
}

.btn-remover-vinculo:hover {
    color: var(--cor-erro, #c00);
}

.modal-mask {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.modal-confirmacao {
    background: var(--cor-fundo, #fff);
    border-radius: 8px;
    padding: 1.25rem;
    min-width: 320px;
    max-width: 90vw;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-confirmacao .modal-header {
    margin-bottom: 0.75rem;
}

.modal-confirmacao .modal-header h3 {
    margin: 0;
    font-size: 1.1rem;
}

.modal-confirmacao .modal-body {
    margin: 0 0 1.25rem;
    color: var(--cor-texto, #333);
}

.modal-confirmacao .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
}
</style>
